import { render, staticRenderFns } from "./Spelling.vue?vue&type=template&id=249144c6&scoped=true&"
import script from "./Spelling.vue?vue&type=script&lang=js&"
export * from "./Spelling.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "249144c6",
  null
  
)

export default component.exports